import { useState, useRef } from "react";
import LoadingSpinner from "../LoadingSpinner";
import { isEnter, isSpace } from "../../helpers/keyHelper";
import "./contributionImage.scss";
import { setMedia, selectors } from "../../app/slices/mediaSlice";
import { connect } from "react-redux";

function ContributionImage(props) {
  const [imageLoaded, setImageLoaded] = useState(false);
  const [brokenImage, setBrokenImage] = useState(false);

  const {
    id,
    onClick,
    url,
    quality,
    mediaArrayLength,
    itemIndex,
    media,
    setMedia,
    allowFullScreen
  } = props;
  
  const img = useRef(null);
  let altText = "User submitted image";

  const { REACT_APP_IMAGEPATH } = process.env;
  const brokenImagePath = `${REACT_APP_IMAGEPATH}/broken-image.svg`;

  //If the given image has a description, use it as the alt text
  props.description && (altText = props.description);

  function handleKeyPress(e) {
    if (isSpace(e) || isEnter(e)) {
      e.preventDefault();
      img.current.click();
    }
  }

  function generateUrl(width, height, brokenImage) {
    if (brokenImage) {
        return `${brokenImagePath}?autorotate=true&width=${width.toString()}&height=${height.toString()}&mode=crop&quality=${quality}`;
    }
      return `${url}?autorotate=true&width=${width.toString()}&height=${height.toString()}&mode=crop&quality=${quality}`;
  }

  function onError(e) {
    setBrokenImage(true);

    if (media !== undefined || media !== null) {
      for (let i = 0; i < media.length; i++) {
        if (media[i].url === url) {
          // Get all the media items, and get the media item
          let updatedMedia = [...media];
          let updateMediaItem = { ...media[i] };
          // Set the url to the broken image path
          updateMediaItem.url = brokenImagePath;
          // Update the media with the new media with the broken image path
          updatedMedia[i] = updateMediaItem;
          setMedia(updatedMedia);
        }
      }
    }

    setImageLoaded(true);
  }

  function Source() {
    const isOnlyItemInArray = mediaArrayLength === 1;
    const isLastItemInOddNumberedArray =
      mediaArrayLength % 2 === 1 && itemIndex === mediaArrayLength - 1;

    if (isOnlyItemInArray || isLastItemInOddNumberedArray) {
      // Full width image
      return (
        <>
          <source
            srcSet={generateUrl(915, 560, brokenImage)}
            media="(min-width: 1180px)"
          />
          <source
            srcSet={generateUrl(740, 455, brokenImage)}
            media="(min-width: 1000px)"
          />
          <source
            srcSet={generateUrl(950, 620, brokenImage)}
            media="(min-width: 750px)"
          />
        </>
      );
    } else if (mediaArrayLength === 2) {
      // Half width, full height image
      return (
        <>
          <source
            srcSet={generateUrl(450, 565, brokenImage)}
            media="(min-width: 1180px)"
          />
          <source
            srcSet={generateUrl(360, 455, brokenImage)}
            media="(min-width: 1000px)"
          />
          <source
            srcSet={generateUrl(460, 620, brokenImage)}
            media="(min-width: 750px)"
          />
        </>
      );
    } else {
      // Half width, reduced height image
      return (
        <>
          <source
            srcSet={generateUrl(450, 275, brokenImage)}
            media="(min-width: 1180px)"
          />
          <source
            srcSet={generateUrl(360, 220, brokenImage)}
            media="(min-width: 1000px)"
          />
          <source
            srcSet={generateUrl(460, 295, brokenImage)}
            media="(min-width: 750px)"
          />
        </>
      );
    }
  }

  return (
    <div className="ugc__contribution-image">
      <picture>
        <>
          <Source/>
          <source
            srcSet={generateUrl(750, 550, brokenImage)}
            media="(min-width: 600px)"
          />
          <source
            srcSet={generateUrl(600, 440, brokenImage)}
            media="(min-width: 450px)"
          />
          <source srcSet={generateUrl(450, 330, brokenImage)}/>
        </>
        <img
          id={id}
          ref={img}
          onClick={onClick}
          onKeyDown={handleKeyPress}
          alt={altText}
          src="data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs="
          data-component="ugcImageGalleryLaunch"
          data-component-label="ugcImage"
          onLoad={() => setImageLoaded(true)}
          onError={(e) => onError(e)}
          itemProp="image"
        />
      </picture>
      {
        allowFullScreen &&
        <button
          className="govuk-button he-button he-button__primary"
          type="button"
          onClick={onClick}
          data-component="ugcImageGalleryLaunch"
          data-component-label="ugcImageButton"
          onKeyDown={handleKeyPress}>
          <span className="sr-only">Show image in gallery</span>
          <span className="icon icon--fullscreen"/>
        </button>
      }
      {
        !imageLoaded && props.hideLoadingSpinner &&
        <LoadingSpinner/>
      }
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    media: selectors.media(state),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setMedia: (media) => dispatch(setMedia(media)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ContributionImage);
